import * as React from 'react';
import * as _ from 'lodash';

import { CheckboxWithDisplayDisplayPart } from '@blend/consumer-components';
import Checkbox from '../CheckboxInput/CheckboxInput';
import TextScreenModal from '../../TextScreenModal/TextScreenModal';

namespace BaseRequirementInput {
  export type OpenModal = (textScreenId: string, headerText: string) => void;

  export type DisplayPart = CheckboxWithDisplayDisplayPart;

  export interface Props extends InputProps {
    generateDisplayParts: (openModal: OpenModal) => DisplayPart[];
  }

  export interface State {
    modalOpen: boolean;
    headerText: string;
    textScreenId: string;
  }
}

// A base component consumed by both RequirementInput and UnformattedRequirementInput. Centralizes modal logic for
// use by both. This component is not intended to be directly consumed; you should use UnformattedRequirementInput or
// RequirementInput instead.
class BaseRequirementInput extends React.PureComponent<BaseRequirementInput.Props> {
  state = {
    modalOpen: false,
    headerText: '',
    textScreenId: '',
  };

  openModal = (textScreenId: string, headerText: string) => {
    this.setState({
      modalOpen: true,
      headerText,
      textScreenId,
    });
  };

  dismissModal = () => {
    this.setState({ modalOpen: false });
  };

  render() {
    const {
      generateDisplayParts,
      hidePlaceholder: _hidePlaceholder,
      identifier: _identifier,
      ...inputProps
    } = this.props;
    const { headerText, modalOpen, textScreenId } = this.state;

    return (
      <React.Fragment>
        <Checkbox
          {...inputProps}
          identifier={_.get(inputProps, 'input.name', 'Checkbox')}
          displayParts={generateDisplayParts(this.openModal)}
        />
        {modalOpen && (
          <TextScreenModal
            data-it="BaseRequirementInput-TextScreenModal"
            textScreenId={textScreenId}
            headerText={headerText}
            contentLabel="Help Dialog"
            isOpen={modalOpen}
            handleClose={this.dismissModal}
          />
        )}
      </React.Fragment>
    );
  }
}

export const RequirementInputConfig = {
  component: BaseRequirementInput,
};

export default BaseRequirementInput;
